<template>
    <a href="javascript:void(0)" @click="openModal"><slot></slot></a>
</template>

<script>
import eventBus from '@/event-bus';

export default {
    props: {
        id: {
            type: String,
            default: ''
        },
        src: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        }
    },
    methods: {
        openModal() {
            eventBus.$emit('videoModalOpened', {
                id: this.id,
                src: this.src,
                title: this.title,
                description: this.description
            });
        }
    }
}
</script>
